import React, { useState, useEffect } from 'react';
import moment from 'moment';
import _, { startCase } from 'lodash';
import { env } from '~/commons/config';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import useSearchParams from '~/commons/hooks/useSearchParams';
import PageHttp from '~/commons/components/PageHttp.jsx';
import ListResource from './ListResource.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';

const api = '/api/core/stocks/trans';

const ListStockRecords = () => {
  const [searchParams, setSearchParams] = useSearchParams(null);

  const showroomIds = _.castArray(env.user.showroom?._id ?? []);
  const [createdDate, setCreatedDate] = useState(null);
  const filter = createdDate ? { createdAt: createdDate } : {};
  const [resSR, reqSR] = useHttpStatus();

  if (searchParams.get('status')) {
    filter.status = searchParams.get('status');
  }
  if (searchParams.get('type')) {
    filter.type = _.first(showroomIds);
  }

  useEffect(() => {
    reqSR({ url: '/api/core/users/self/showrooms' });
  }, []);

  return (
    <PageHttp res={[resSR]}>
      {([showrooms]) => (
        <ListResource
          {...{
            searchable: [
              { value: 'refCode', label: 'Stock Transfer Number' },
              {
                value: 'from._id',
                label: 'From',
                options: _.map(showrooms, (x) => ({
                  value: x._id,
                  label: [x.orgId, x.showroom].filter(Boolean).join(' - '),
                })),
              },
              {
                value: 'to._id',
                label: 'To',
                options: _.map(showrooms, (x) => ({
                  value: x._id,
                  label: [x.orgId, x.showroom].filter(Boolean).join(' - '),
                })),
              },
              { value: 'createdBy', label: 'Created By' },
            ],
            api,
            filter,
            sort: { createdAt: -1 },
            actions: {
              remove: false,
            },
            cols: [
              { key: 'refCode', children: 'Stock Transfer Number' },
              {
                key: 'type',
                sortable: true,
                children: 'Type',
                getter: (v, r) => {
                  const from = r.from ? _.indexOf(showroomIds, r.from._id) : -1;
                  const to = r.to ? _.indexOf(showroomIds, r.to._id) : -1;
                  if (to !== -1) return 'Inbound';
                  if (from !== -1) return 'Outbound';
                  return '';
                },
              },
              {
                key: 'itemsSize',
                sortable: true,
                children: 'Quantity',
                getter: (v, r) => r?.items?.length ?? 0,
              },
              {
                key: 'from.orgId',
                children: 'From',
                dataClass: 'text-nowrap',
                sortable: true,
                getter: (v, r) => {
                  const out = [
                    r?.from?.orgId,
                    r?.from?.showroom,
                  ];
                  return out.filter(Boolean).join(' - ');
                },
              },
              {
                key: 'to.orgId',
                children: 'To',
                dataClass: 'text-nowrap',
                sortable: true,
                getter: (v, r) => {
                  const out = [r?.to?.orgId, r?.to?.showroom];
                  return out.filter(Boolean).join(' - ');
                },
              },
              {
                key: 'createdAt',
                sortable: true,
                getter: (v) => (v
                  ? moment(v).format(env.f.dt)
                  : ''),
              },
              {
                key: 'createdBy.username',
                sortable: true,
                children: 'Created By',
              },
              {
                key: 'status',
                sortable: true,
                getter: (v) => (v ? startCase(v) : ''),
              },
            ],
            ctrls: [
              <select
                name="status"
                className="custom-select"
                key={0}
                value={(searchParams.get('status') ? searchParams.get('status') : '')}
                onChange={(e) => {
                  setSearchParams({ status: e.target.value });
                }}>
                <option value="">Status</option>
                {(env?.status?.stockTrans).map((a) => (
                  <option key={a} value={a}>
                    {a}
                  </option>
                ))}
              </select>,
              <select
                name="type"
                className="custom-select"
                key={0}
                value={(searchParams.get('type') ? searchParams.get('type') : '')}
                onChange={(e) => {
                  setSearchParams({ type: e.target.value });
                }}>
                <option value="">Type</option>
                <option value="to">Inbound</option>
                <option value="from">Outbound</option>
              </select>,
            ],
          }}>
          {() => (
            <>
              <BtnDayRangePicker
                className="float-right ml-2"
                value={createdDate}
                onChange={setCreatedDate}
                placeholder={'Created At'}
              />
            </>
          )}
        </ListResource>
      )}
    </PageHttp>
  );
};

export default ListStockRecords;
